import { DropdownMenu, DropdownItem } from '@raptormaps/dropdown-menu';
import { Button } from '@raptormaps/button';
import { useMixpanel } from '../../hooks/useMixpanel';

interface ExportSolarOrdersDropdownProps {
  exportSolarOrders: (key: string) => void;
}

export const ExportOrdersDropdown = ({
  exportSolarOrders,
}: ExportSolarOrdersDropdownProps) => {
  const mixpanel = useMixpanel();

  const dropdownOptions: DropdownItem[] = [
    {
      variant: 'option',
      value: 'Completed',
      onSelect: () => {
        mixpanel('Export completed solar orders');
        exportSolarOrders('completed');
      },
    },
    {
      variant: 'option',
      value: 'Ongoing',
      onSelect: () => {
        mixpanel('Export ongoing solar orders');
        exportSolarOrders('ongoing');
      },
    },
  ];

  return (
    <DropdownMenu items={dropdownOptions}>
      <Button variant="tertiary">Export Orders</Button>
    </DropdownMenu>
  );
};
